import { DatePicker, DatePickerOptions } from '@ionic-native/date-picker';

export class DatePickerMock extends DatePicker {

    show(options?: DatePickerOptions): Promise<Date> {

        return new Promise((resolve, reject) => {

            let date: Date = new Date();
            date.setDate(date.getDate() + 2);

            resolve(date);

        });
    }
}



// WEBPACK FOOTER //
// ./src/providers/mock/date-picker-mock.ts